import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: string, firstName: string, lastName: string, profilePhotoLink?: string | null, email: string, isHighnoteAdmin?: boolean | null, isWorkspaceAdmin?: boolean | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null, isContributor?: boolean | null, isEnabled?: boolean | null, roleId?: number | null, specialtyId?: any | null, workspaceLocationId?: number | null, role?: { __typename?: 'roles', id: number, name: string, parentId?: number | null, roleGroup?: { __typename?: 'roles', id: number, name: string } | null } | null, userSpecialty?: { __typename?: 'specialties', id: any, name: string, parentId?: any | null, specialtyGroup?: { __typename?: 'specialties', id: any, name: string } | null } | null, workspaces: Array<{ __typename?: 'workspaceUsers', workspaceId: number, workspace: { __typename?: 'workspaces', id: number, name: string, aiAnswersEnabled?: boolean | null, inactivityDetectionEnabled?: boolean | null, inactivityLimitMsec?: number | null, locations: Array<{ __typename?: 'workspaceLocations', id: number, name: string, workspaceId: number, abbreviation?: string | null }>, mentorshipPrograms: Array<{ __typename?: 'mentorshipProgram', id: number, name: string, workspaceId: number, workspaceLocationId?: number | null }> } }>, workspaceLocation?: { __typename?: 'workspaceLocations', name: string, abbreviation?: string | null, id: number, city?: string | null, state?: string | null, mentorshipPrograms: Array<{ __typename?: 'mentorshipProgram', id: number, name: string, workspaceId: number, workspaceLocationId?: number | null }> } | null } | null };


export const GetUserDocument = gql`
    query getUser($id: String!) {
  users_by_pk(id: $id) {
    id
    firstName
    lastName
    profilePhotoLink
    email
    isHighnoteAdmin
    isWorkspaceAdmin
    mentorEnabled
    menteeEnabled
    isContributor
    isEnabled
    roleId
    role {
      id
      name
      parentId
      roleGroup {
        id
        name
      }
    }
    specialtyId
    userSpecialty {
      id
      name
      parentId
      specialtyGroup {
        id
        name
      }
    }
    workspaces(where: {workspace: {active: {_eq: true}}}) {
      workspaceId
      workspace {
        id
        name
        aiAnswersEnabled
        locations(where: {active: {_eq: true}}) {
          id
          name
          workspaceId
          abbreviation
        }
        inactivityDetectionEnabled
        inactivityLimitMsec
        mentorshipPrograms {
          id
          name
          workspaceId
          workspaceLocationId
        }
      }
    }
    workspaceLocationId
    workspaceLocation {
      name
      abbreviation
      id
      city
      state
      mentorshipPrograms {
        id
        name
        workspaceId
        workspaceLocationId
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;